module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18dqAUL/tc-custom/9781439678688.jpg?1704887001526",
      "alt": "This image is the cover for the book Historic Tales of Fort Benton, American Legends"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Historic Tales of Fort Benton, American Legends\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v(" \"…more romance, tragedy and vigorous life than many a city a hundred times its size and ten times its age.\" - Historian Hiram M. Chittenden ")])]), _c('br'), _c('p', [_vm._v(" Deep in the heart of Blackfoot country on the Upper Missouri River, trade relations opened cautiously in 1831. A series of trading posts and clashes followed. By 1846, Fort Benton had become the center of commerce with Indigenous tribes, including the Blackfoot who dubbed it \"many houses to the South.\" Drawing settlers from eastern states, the head of steamboat navigation became known as \"the world's innermost port.\" As a result, the fort became a multicultural melting pot and home to the \"Bloodiest Block in the West.\" Award-winning historian Ken Robison brings to life dramatic sagas of a rapidly developing frontier, from vigilante X. Beidler to the Marias and Ophir Massacres.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ken Robison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Native Montanan Ken Robison is the historian at the Overholser Historical Research Center and for the Great Falls/Cascade County Historic Preservation Commission and is active in historic preservation throughout central Montana. He is a retired navy captain after a career in naval intelligence. The Montana Historical Society honored Ken as \"Montana Heritage Keeper\" in 2010.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0